module.exports = __webpack_public_path__ + "14ffe0596bfd0636438d85028bd59c0e.png";